import { render, staticRenderFns } from "./UpdateSubrole.vue?vue&type=template&id=116736c0"
import script from "./UpdateSubrole.vue?vue&type=script&lang=js"
export * from "./UpdateSubrole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports